export default "__VITE_ASSET__CDD31P$O__"